import React from 'react';
import {
  flexRender,
  Table,
} from '@tanstack/react-table';
import './ScreenerTable.css';

interface ScreenerTableProps<T> {
  table: Table<T>;
  className?: string;
}

// Helper function for column-specific CSS classes
const getColumnClass = (columnId: string) => {
  switch (columnId) {
    case 'symbol':
      return 'symbol-cell';
    case 'company':
      return 'company-cell';
    default:
      return 'score-cell';
  }
};

function ScreenerTable<T>({ table, className = "" }: ScreenerTableProps<T>) {
  return (
    <section className={`screener-table-section ${className}`}>
      <div className="section-container">
        <div className="table-wrapper">
          <table className="screener-table">
            <thead>
              {table.getHeaderGroups().map(headerGroup => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map(header => {
                    return (
                      <th 
                        key={header.id}
                        className={`sortable ${header.column.getCanSort() ? 'cursor-pointer' : ''} ${
                          header.column.getIsSorted() ? 'active' : ''
                        }`}
                        onClick={header.column.getToggleSortingHandler()}
                      >
                        <div className="header-content">
                          {header.isPlaceholder
                            ? null
                            : flexRender(
                                header.column.columnDef.header,
                                header.getContext()
                              )}
                          <span className="sort-indicator">
                            {{
                              asc: ' ↑',
                              desc: ' ↓',
                            }[header.column.getIsSorted() as string] ?? ' ↕️'}
                          </span>
                        </div>
                      </th>
                    )
                  })}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map(row => (
                <tr key={row.id} className="table-row">
                  {row.getVisibleCells().map(cell => (
                    <td key={cell.id} className={getColumnClass(cell.column.id)}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

export default ScreenerTable;
